/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import {
  StackLayout,
  StackItem,
  Box,
  Button,
  GDSStyleObject,
} from '@leagueplatform/genesis-core';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { useIntl } from '@leagueplatform/locales';
import { FooterMultiStepProgress } from '../step-navigation/footerMultiStepProgress';
import COBQuestioner from '../../assets/json/COB_QUESTIONER.json';

import {
  OtherInsurance,
  MedicareInsurance,
  CobLanding,
  MedicareDependants,
  OtherDependants,
  OtherQuestioner,
} from '../forms';

import { COB_API_TYPE, CobInfo } from '../../types/online-forms.types';

import useCobStore from '../../store/cob-store';

import { ErrorModal } from '../step-navigation/errorModal';
import { CheckFlow } from '../forms/form-instruction/check-flow/check-flow';
import { cobLibrary } from '../../cob-library.config';
import { getPartnerToken, getAccessToken } from '../helpers/helpers';

export function Landing() {
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'OTHER_INSURANCE_PAGE' }));
  const [isErrorHandling, setErrorHandling] = useState<boolean>(false);
  const [isNoNext, setNoNext] = useState<boolean>(false);
  const [isValidateForm, setIsValidateForm] = useState<boolean>(false);
  const [isNextDisabled, setIsNextDisabled] = useState<boolean>(false);
  const [iscloseForm, setCloseForm] = useState<boolean>(false);
  const initialCOB = useCobStore((state: any) => state.initialCOB);
  const [OPISINFO, setOPISINFO] = useState<CobInfo>(initialCOB);
  const [partnerToken, setPartnerToken] = useState<string | null>(null);

  const config = cobLibrary.getConfig();
  const { HIGHMARK_API_URL, useCurrentRegionUbkHeader } = config;
  const currentUbk: any = useCurrentRegionUbkHeader() || null;
  const ubkValue = currentUbk?.headers?.Brandubk || null;
  const reteriveURL = `${HIGHMARK_API_URL}/digital/v2/members/coordination-of-benefits/form`;
  const plansURL = `${HIGHMARK_API_URL}/digital/v1/members/benefits/plans?planYear=all`;
  const demographicURL = `${HIGHMARK_API_URL}/digital/v1/members/demographics/profile`;
  const [apiData, setApiData] = useState(null);
  const [errorMsg, setErrorMsg] = useState(false);
  const blog = {
    likeStatus: false,
  };
  const [liked, setLiked] = useState(blog.likeStatus);
  const countref = useRef(1);

  const getIdentityToken = async () => {
    if (!partnerToken) {
      const response = await getPartnerToken();
      if (response) {
        if (response.token) {
          setPartnerToken(response?.token);
          return;
        }
        if (response.errMsg) {
          setPartnerToken(null);
          setErrorMsg(true);
        }
      }
    }
  };

  useEffect(() => {
    const likeAPI = (status: string) => {};

    if (partnerToken) {
      getAccessToken(demographicURL, partnerToken, ubkValue).then(
        (result: any) => {
          // retry.current += 1;
          const errData = result?.errMsg;
          if (errData) {
            const status = liked ? 'LOADING' : 'CLOSED';
            likeAPI(status);
            setErrorMsg(true);
            document.getElementById('errorBtn')?.click();
          } else {
            setApiData(result);
            setErrorMsg(false);
          }
        },
      );
    } else {
      getIdentityToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [demographicURL, liked, ubkValue, partnerToken]);

  const saveCobInformation = useCobStore((state: any) => state.saveCOBInfo);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  let profileInfo: any = [];

  let opisResponse: any;

  sessionStorage.clear();
  if (apiData) {
    profileInfo = apiData;
    if (
      OPISINFO?.additionalInsurance === null ||
      (OPISINFO?.additionalInsurance?.length === 0 &&
        OPISINFO?.medicare?.length === 0)
    ) {
      // eslint-disable-next-line prefer-destructuring
      opisResponse = initialCOB; // initialCOB[0];
      saveCobInformation(opisResponse);
      sessionStorage.setItem('COBType', 'New');
      opisResponse.groupNumber = OPISINFO?.groupNumber;
    } else {
      opisResponse = OPISINFO;
      const checkIssubscriber = OPISINFO?.additionalInsurance?.find(
        (item: any) =>
          item.member.firstName === profileInfo?.demographics?.firstName,
      );
      const checkisDeptOpted = OPISINFO?.additionalInsurance?.find(
        (item: any) => item.hasAdditionalInsurance !== '',
      );
      if (checkIssubscriber === undefined && checkisDeptOpted !== undefined) {
        const deptDetails = OPISINFO.additionalInsurance;
        const subscriberDetail = initialCOB.additionalInsurance[0];
        subscriberDetail.member.firstName =
          profileInfo?.demographics?.firstName;
        subscriberDetail.member.lastName = profileInfo?.demographics?.lastName;
        const subscriberDetailResponse = [subscriberDetail, ...deptDetails];
        opisResponse.additionalInsurance = subscriberDetailResponse;
      }
    }
  }
  const saveDemographic = useCobStore(
    (state: any) => state.saveDemographicsInfo,
  );

  const componentList: any = [];

  const closeWholeForm = () => {
    if (countref.current === 4) {
      document.getElementById('closeBtn')?.click();
      navigate('/home');
    } else {
      setLiked(!liked);
      setErrorMsg(false);
      countref.current += 1;
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const withoutDependent = [
    <CobLanding
      nextButtonClicked={isValidateForm}
      errorHandling={(val: boolean) => setErrorHandling(val)}
      nextDisabled={(val: boolean) => setIsNextDisabled(val)}
      showFooter="true"
      startNow="true"
      noNext={() => setNoNext(false)}
    />,
    <OtherInsurance
      nextButtonClicked={isValidateForm}
      errorHandling={(val: boolean) => setErrorHandling(val)}
      nextDisabled={(val: boolean) => setIsNextDisabled(val)}
      showFooter="true"
      isOtherNoDept="true"
      currentValue="2"
      noNext={() => setNoNext(false)}
    />,
    <MedicareInsurance
      nextButtonClicked={isValidateForm}
      errorHandling={(val: boolean) => setErrorHandling(val)}
      nextDisabled={(val: boolean) => setIsNextDisabled(val)}
      showFooter="true"
      noNext={(val: boolean) => setNoNext(val)}
      isMedicareNoDept="true"
      endValue="3"
    />,
    <CheckFlow partnerToken={partnerToken} />,
  ];

  const withDependents = [
    <CobLanding
      nextButtonClicked={isValidateForm}
      errorHandling={(val: boolean) => setErrorHandling(val)}
      nextDisabled={(val: boolean) => setIsNextDisabled(val)}
      showFooter="true"
      startNow="true"
    />,
    <OtherInsurance
      nextButtonClicked={isValidateForm}
      errorHandling={(val: boolean) => setErrorHandling(val)}
      nextDisabled={(val: boolean) => setIsNextDisabled(val)}
      showFooter="true"
      noNext={() => setNoNext(false)}
    />,
    <MedicareInsurance
      nextButtonClicked={isValidateForm}
      errorHandling={(val: boolean) => setErrorHandling(val)}
      nextDisabled={(val: boolean) => setIsNextDisabled(val)}
      showFooter="true"
      noNext={(val: boolean) => setNoNext(val)}
    />,
    <OtherDependants
      nextButtonClicked={isValidateForm}
      errorHandling={(val: boolean) => setErrorHandling(val)}
      showFooter="true"
      noNext={() => setNoNext(false)}
    />,
    <MedicareDependants
      nextButtonClicked={isValidateForm}
      errorHandling={(val: boolean) => setErrorHandling(val)}
      nextDisabled={(val: boolean) => setIsNextDisabled(val)}
      showFooter="true"
      noNext={(val: boolean) => setNoNext(val)}
      isMedicareDept="true"
      endValue="5"
    />,
    <OtherQuestioner partnerToken={partnerToken} />,
  ];

  useEffect(() => {
    saveDemographic(profileInfo);
    saveCobInformation(opisResponse);
  }, [opisResponse, profileInfo, saveCobInformation, saveDemographic]);

  useEffect(() => {
    if (iscloseForm) {
      // eslint-disable-line no-empty
    }
  }, [iscloseForm]);

  if (apiData && profileInfo?.length !== 0) {
    if (
      profileInfo.demographics.dependents?.length >= 1 &&
      profileInfo.demographics.dependents !== null
    ) {
      componentList.push(...withDependents);
    } else {
      componentList.push(...withoutDependent);
    }
  }

  useEffect(() => {
    if (partnerToken) {
      getAccessToken(plansURL, partnerToken, ubkValue).then((result: any) => {
        const plansData = result?.plans;
        // const errData = result?.errMsg;
        if (plansData) {
          const findPlanType = plansData.find(
            (item: any) =>
              item.planType === 'medical' || item.planType === 'Medical',
          );
          const { groupNumber } = findPlanType;
          localStorage.setItem('groupNumber', groupNumber);
        }
      });
      getAccessToken(reteriveURL, partnerToken, ubkValue).then(
        (result: any) => {
          const errData = result?.errMsg;
          if (!errData) {
            const opisInfo = result;
            if (opisInfo) {
              saveCobInformation(result);
              setOPISINFO(result);
            }
          } else {
            saveCobInformation(initialCOB);
          }
        },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    initialCOB,
    plansURL,
    reteriveURL,
    saveCobInformation,
    ubkValue,
    partnerToken,
  ]);

  return (
    <StackLayout
      horizontalAlignment="center"
      css={{ position: 'relative', minHeight: '100vh' }}
    >
      {profileInfo?.length === 0 && !errorMsg && !partnerToken && (
        <StackItem
          css={{
            textAlign: 'center',
            zIndex: '200',
            top: '50px',
            backgroundColor: '#CCCCCC',
            marginBottom: '20px',
          }}
        >
          <LoadingIndicator />
        </StackItem>
      )}

      {profileInfo !== null && partnerToken && (
        <FooterMultiStepProgress
          list={componentList}
          handleFormOrNext={isErrorHandling}
          isValidateForm={(val: boolean) => setIsValidateForm(val)}
          closeForm={(val: boolean) => setCloseForm(val)}
          formName={COB_API_TYPE.OTHER_INSURANCE}
          checkNoNext={isNoNext}
          isNextDisabled={isNextDisabled}
          partnerToken={partnerToken}
        />
      )}
      {profileInfo?.length === 0 && (
        <>
          {/* // need to revisit while failing status  */}
          {errorMsg && countref.current <= 4 && (
            <ErrorModal
              onClose={() => {
                closeWholeForm();
              }}
            />
          )}
          {profileInfo?.length === 0 && !errorMsg && !partnerToken && (
            <StackItem
              css={{
                textAlign: 'center',
                zIndex: '200',
                top: '50px',
                backgroundColor: '#CCCCCC',
                marginBottom: '20px',
              }}
            >
              <LoadingIndicator />
            </StackItem>
          )}
          <StackLayout
            horizontalAlignment="center"
            css={
              {
                opacity: 0.6,
                maxHeight: '75vh',
                marginTop: '-20px',
              } as GDSStyleObject
            }
            data-testid="landingLayout"
          >
            <CobLanding
              nextButtonClicked={isValidateForm}
              errorHandling={(val: boolean) => setErrorHandling(val)}
              nextDisabled={(val: boolean) => setIsNextDisabled(val)}
              showFooter="true"
              startNow="true"
            />
          </StackLayout>
          <Box
            css={{
              border: '0px solid #000000',
              backgroundColor: '#F8F8F8',
              display: 'flex',
            }}
          >
            <StackLayout
              css={
                {
                  padding: '$none $none',
                  marginLeft: '0px',
                  border: '0px solid #000000',
                  flex: 1,
                  '@desktop': { height: '80px', width: '60px' },
                  '@mobile': { height: '80px', width: '90px' },
                  // eslint-disable-next-line react/no-children-prop
                } as GDSStyleObject
              }
              // eslint-disable-next-line react/no-children-prop
              children={undefined}
            />
            <StackLayout
              css={
                {
                  flex: 1,
                  padding: '$none $none',
                  border: '0px solid #000000',
                  '@desktop': { height: '80px', width: '60px' },
                  '@mobile': { height: '80px', width: '90px' },
                  // eslint-disable-next-line react/no-children-prop
                } as GDSStyleObject
              }
              // eslint-disable-next-line react/no-children-prop
              children={undefined}
            />
            <StackLayout
              css={
                {
                  maxHeight: '150px',
                  border: '0px solid #000000',
                  padding: '$none $none',
                  flex: 1,
                  '@desktop': {
                    padding: '$none $none',
                    marginLeft: '160px',
                    marginTop: '40px',
                    height: '60px',
                    width: '200px',
                  },
                  '@mobile': {
                    padding: '$none $none',
                    marginLeft: '0px',
                    marginTop: '0px',
                    height: '60px',
                    width: '230px',
                  },
                } as GDSStyleObject
              }
            >
              <Button
                size="small"
                css={{
                  marginRight: '20px',
                  paddingLeft: '34px',
                  height: '48px',
                  width: '134px',
                  color: '#FFFFFF',
                  cursor: 'pointer',
                  backgroundColor: '$primaryBackgroundDefault',
                  fontSize: '$bodyOne',
                  fontWeight: '$semibold',
                  '@mobile': {
                    height: '48px',
                    paddingRight: '10px',
                    paddingTop: '20px',
                    paddingBottom: '20px',
                    paddingLeft: '35px',
                    marginRight: '15px',
                    marginTop: '40px',
                  },
                }}
                disabled
              >
                {COBQuestioner.COB.Buttons.STARTNOW}
              </Button>
            </StackLayout>
          </Box>
        </>
      )}
      {/* {errMsg && <ErrorModal onClose={closeForm} />} */}
    </StackLayout>
  );
}
// export default Landing;
